/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_5_SolutionInputs */

const et_portfolio_project_5_solution = /** @type {(inputs: Portfolio_Project_5_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehitasime ümber kiiruse, turvalisuse ja SEO jaoks jõudluspõhise arhitektuuriga.`)
};

const en_portfolio_project_5_solution = /** @type {(inputs: Portfolio_Project_5_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebuilt for speed, security, and SEO with a performance-first architecture.`)
};

/**
* | output |
* | --- |
* | "Rebuilt for speed, security, and SEO with a performance-first architecture." |
*
* @param {Portfolio_Project_5_SolutionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_5_solution = /** @type {((inputs?: Portfolio_Project_5_SolutionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_5_SolutionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_5_solution(inputs)
	return en_portfolio_project_5_solution(inputs)
});